var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "page-title-container" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(_vm._s(_vm.pageTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ml-2 btn btn-primary pull-right themebutton",
                attrs: {
                  type: "button",
                  id: "cancelTrainingEmailManagerAttachment"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack.apply(null, arguments)
                  }
                }
              },
              [_c("span", [_vm._v("Back")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "forms-container default-bx-shadow responsive-forms-container"
            },
            [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "location",
                          placeholder: "Select Location",
                          options: _vm.locationArr,
                          clearable: false
                        },
                        on: {
                          input: function($event) {
                            _vm.locationError = ""
                          }
                        },
                        model: {
                          value: _vm.location,
                          callback: function($$v) {
                            _vm.location = $$v
                          },
                          expression: "location"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.locationError))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "department",
                          label: "text",
                          options: _vm.departmentArr,
                          clearable: false,
                          placeholder: "Select Department"
                        },
                        on: {
                          input: function($event) {
                            _vm.departmentError = ""
                          }
                        },
                        model: {
                          value: _vm.department,
                          callback: function($$v) {
                            _vm.department = $$v
                          },
                          expression: "department"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.departmentError))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-tags-input", {
                        attrs: {
                          tags: _vm.toEmailTagsArr,
                          validation: _vm.validation,
                          placeholder: ""
                        },
                        on: {
                          "tags-changed": _vm.handleToEmlTagsChanged,
                          "before-adding-tag": _vm.checkToEmailTag,
                          input: function($event) {
                            _vm.toEmailError = ""
                          }
                        },
                        model: {
                          value: _vm.toEmail,
                          callback: function($$v) {
                            _vm.toEmail = $$v
                          },
                          expression: "toEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.toEmailError))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-tags-input", {
                        attrs: {
                          tags: _vm.ccEmailTagsArr,
                          validation: _vm.validation,
                          placeholder: ""
                        },
                        on: {
                          "tags-changed": function(newTags) {
                            return (_vm.ccEmailTagsArr = newTags)
                          },
                          "before-adding-tag": _vm.checkCCEmailTag
                        },
                        model: {
                          value: _vm.ccEmail,
                          callback: function($$v) {
                            _vm.ccEmail = $$v
                          },
                          expression: "ccEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.ccEmailError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.location.name == "All"
                  ? _c("div", { staticClass: "col-12 forms-block" }, [
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(
                          "NOTE: Selected email address will get the summary report as an executive."
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "mr-17 pb-12 float-l" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "ml-2 btn btn-primary pull-right themebutton",
                      attrs: {
                        type: "button",
                        id: "cancelTrainingEmailManagerAttachment"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack.apply(null, arguments)
                        }
                      }
                    },
                    [_c("span", [_vm._v("Cancel")])]
                  ),
                  _vm._v(" "),
                  _vm.edit_id == 0
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "ml-2 btn btn-primary pull-right themebutton",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addEmailManagerData(
                                "save_and_continue"
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { id: "saveAndContinueAttachment" } },
                            [_vm._v("Save And Continue")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "ml-2 btn btn-primary pull-right themebutton",
                      attrs: { type: "submit" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.addEmailManagerData("save")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { id: "createTrainingEmailManager" } },
                        [_vm._v("Save")]
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Location :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Department :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("To Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("CC Email :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1ce517e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1ce517e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrainingEmailManager/AddUpdateTrainingEmailManager.vue
// module id = null
// module chunks = 